import { render, staticRenderFns } from "./level.vue?vue&type=template&id=66642427&scoped=true"
import script from "./level.vue?vue&type=script&lang=ts"
export * from "./level.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66642427",
  null
  
)

export default component.exports